// import scroll from './scroll'
// import resize from './resize'
import GlobalListener from './global-listener'

export default new GlobalListener()
const rafListener = new GlobalListener()

export { rafListener }
